import { useKeyPress } from '@pairy/react-hooks';
import { PropsWithChildren, useEffect } from 'react';

import useGetFirstVisit from '../../../../hooks/useGetFirstVisit';

import * as Styled from './index.styles';

interface DesktopIntroProps {
  translateKoToEn: (item: string) => string;
}

const DesktopIntro = ({ translateKoToEn }: DesktopIntroProps) => {
  const [isUserFirstVisit, setIsUserFirstVisit] = useGetFirstVisit();

  const isPressPageMoveKeys = useKeyPress(
    'ArrowLeft, ArrowUp, ArrowRight, ArrowDown, PageUp, PageDown',
  );

  useEffect(() => {
    if (isPressPageMoveKeys) {
      setIsUserFirstVisit(false);
    }
  }, [isPressPageMoveKeys]);

  if (!isUserFirstVisit) {
    return null;
  }

  return (
    <Styled.FlexWrapper
      alignItems="center"
      justifyContent="center"
      onClick={() => {
        setIsUserFirstVisit(false);
      }}
    >
      <Text>
        {translateKoToEn('initMessage-first')}
        <br />
        {translateKoToEn('initMessage-second')}
      </Text>
    </Styled.FlexWrapper>
  );
};

export default DesktopIntro;

const Text = ({ children }: PropsWithChildren) => (
  <Styled.Text variant="2xl-semibold" color="white" textAlign="center">
    {children}
  </Styled.Text>
);
